module.exports = __webpack_public_path__ + "static/media/Madhura Chavan.9b0da95d.png";